import type { MetaDescriptor } from 'react-router';

import { getPathnameWithLocale } from '@/utils/urlUtils';
import i18n from '~/i18n';

export const getSeoLinks = ({
  requestUrl,
  locale,
  pathname,
}: {
  requestUrl: string;
  locale: string;
  pathname: string;
}): MetaDescriptor[] => {
  const url = new URL(requestUrl);
  url.protocol = 'https:';
  const base = url.origin;

  return [
    {
      tagName: 'link',
      rel: 'canonical',
      href: new URL(getPathnameWithLocale(pathname, locale), base).toString(),
    },
    {
      tagName: 'link',
      rel: 'alternate',
      hrefLang: 'x-default',
      href: new URL(
        getPathnameWithLocale(pathname, undefined),
        base,
      ).toString(),
    },
    ...i18n.supportedLngs.map((locale) => {
      return {
        tagName: 'link',
        rel: 'alternate',
        hrefLang: locale,
        href: new URL(getPathnameWithLocale(pathname, locale), base).toString(),
      };
    }),
  ];
};
